const isReContractAndWithNoSim = productOrder => {
  const { type, sim } = productOrder;
  return type === 'RECON' && !sim.hasSim;
};

export default isReContractAndWithNoSim;
